import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_CART_MARQUEE_LIST}`;

/** 取得跑馬燈 */
export const getMarqueeList = (param) => axios.get(API_PATH, { params: param });
